import { useState, useEffect } from 'react'
import { WarningModal } from 'widget/WarningModal/WarningModal'

// для остановки пулов (выводим модалку)
function useRequestTimeout() {
  const [isTimeUp, setTimeUp] = useState(false)

  useEffect(() => {
    const timeout = setTimeout(() => {
      setTimeUp(true)
    }, 3600000)

    return () => clearTimeout(timeout)
  }, [])

  const handlerClick = () => {
    window.location.reload()
  }

  const Modal = (
    <WarningModal
      buttonText='Обновить'
      modalText='Время сессии истекло, пожалуйста, обновите страницу'
      handlerClick={handlerClick}
      isModalOpen={isTimeUp}
    />
  )

  return { isTimeUp, Modal }
}

export default useRequestTimeout
